import * as React from "react";
import { Modal } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { PickupPointsFinderContainer } from "./PickupPointsFinderContainer.js";
import { PickupLocationInformation } from "../../../../../components/StepShipping/modules/ShippingMethods/components/PickupLocationInformation.js";
import { PickupWarningMessage } from "../../../../../components/StepShipping/modules/ShippingMethods/components/PickupWarningMessage.js";
import { useCheckoutSettings } from "../../../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const PickupPointsContainer = ({
  isTitleHidden = false,
  hasWarningMessageOnly = false,
  onPickupPointSelect,
  selectedPickupPoint,
  onShippingModalClose,
  hasEditButton = true
}) => {
  const { getLabel } = useIntl();
  const { itemsToBeShipped } = useCheckoutSettings();
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  React.useEffect(() => {
    if (!selectedPickupPoint) {
      setModalIsOpen(true);
    }
  }, [selectedPickupPoint]);
  const onPickupModalClose = () => {
    setModalIsOpen(false);
    onShippingModalClose?.();
  };
  const onPickupModalShow = (event) => {
    setModalIsOpen(true);
    event && event.preventDefault();
  };
  const labels = React.useMemo(
    () => ({
      error: getLabel("checkout.pickupPoints.error"),
      noSelection: getLabel("checkout.pickupPoints.selectPoint.message"),
      noSelectionLink: getLabel("checkout.pickupPoints.selectPoint.link"),
      title: getLabel("checkout.pickupPoints.title")
    }),
    [getLabel]
  );
  const handlePickUpPointSelection = React.useCallback(
    (pickupPoint) => {
      if (!pickupPoint) {
        return;
      }
      setModalIsOpen(false);
      onPickupPointSelect(pickupPoint);
    },
    [onPickupPointSelect]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, modalIsOpen && /* @__PURE__ */ React.createElement(
    Modal,
    {
      className: "checkout-step--shipping__modal",
      showIcon: true,
      iconClassName: "checkout-step--shipping__modal__close",
      isOpen: modalIsOpen,
      onModalClose: onPickupModalClose
    },
    /* @__PURE__ */ React.createElement(
      PickupPointsFinderContainer,
      {
        onPickupPointSelect: handlePickUpPointSelection,
        errorMessage: labels.error,
        itemsToBeShipped
      }
    )
  ), selectedPickupPoint && !hasWarningMessageOnly ? /* @__PURE__ */ React.createElement(
    PickupLocationInformation,
    {
      isTitleHidden,
      title: labels.title,
      location: selectedPickupPoint,
      onPickupModalShow: hasEditButton ? onPickupModalShow : void 0
    }
  ) : /* @__PURE__ */ React.createElement(
    PickupWarningMessage,
    {
      labels,
      onPickupModalShow: hasEditButton ? onPickupModalShow : void 0
    }
  ));
};
export {
  PickupPointsContainer
};
//# sourceMappingURL=PickupPointsContainer.js.map
